<template>
  <div
    v-if="straightGray || straightBrand || straightLight"
    class="gl-loader-spin"
  >
    <gl-icon
      :brand="straightBrand"
      :gray="straightGray"
      :height="height"
      :hover="false"
      :light="straightLight"
      name="spinner-straight"
      :width="height"
    />
  </div>
  <div
    v-else-if="spinGrayView"
    class="gl-loader-spin"
  >
    <img
      alt="loader"
      src="~@/assets/svg/loaders/loader-small-gray.svg"
      :style="`height: ${height}`"
    >
  </div>
  <div
    v-else-if="spinBlueView"
    class="gl-loader-spin"
  >
    <img
      alt="loader"
      src="@/assets/svg/loaders/loader-blue.svg"
      :style="`height: ${height}`"
    >
  </div>
  <div
    v-else
    class="gl-loader"
  >
    <img
      alt="loader"
      src="../../public/assets/img/Pre.gif"
      :style="`height: ${height}`"
    >
  </div>
</template>

<script>
// components
import GlIcon from '@/components/gl-icon'
export default {
  components: { GlIcon },
  props: {
    color: {
      type: String,
      default: '#383c54',
    },
    height: {
      type: String,
      default: '50px',
    },
    spinGrayView: {
      type: Boolean,
      default: false,
    },
    spinBlueView: {
      type: Boolean,
      default: false,
    },
    straightGray: {
      type: Boolean,
      default: false,
    },
    straightBrand: {
      type: Boolean,
      default: false,
    },
    straightLight: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
